(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    // var btn = document.querySelector(".hero__cta");
    // if (btn && window.gsap) {
    //   btn.addEventListener("mouseenter", function () {
    //     window.gsap.to(btn, { scale: 1.05, duration: 0.3, ease: "power2.out" });
    //   });

    //   btn.addEventListener("mouseleave", function () {
    //     window.gsap.to(btn, { scale: 1, duration: 0.3, ease: "power2.out" });
    //   });
    // }

    var rotationEl = document.getElementById("dnb__rotation");
    var startRotation = null;
    if (rotationEl) {
      var wordsAttr = rotationEl.getAttribute("data-words") || "";
      var words = wordsAttr
        .split(",")
        .map(function (word) {
          return word.trim();
        })
        .filter(Boolean);
      if (!words.length) {
        words = ["Interfaces", "Experiences", "Interactions", "Visuals"];
      }
      var index = 0;
      var colorPalette = ["#D50C00", "#00ADCF", "#9300A7", "#3C9100", "#FB3D4B", "#FFAE00"];
      var paletteIndex = 0;
      var baseColor = "#000000";
      var currentColor = baseColor;
      var isAnimating = false;
      var alphabet = "abcdefghijklmnopqrstuvwxyz";
      var rotationInterval = null;

      var escapeHtml = function (value) {
        return String(value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
      };

      var renderWord = function (chars, splitIndex, oldColor, newColor) {
        var html = chars
          .map(function (char, idx) {
            var safeChar = char === " " ? "&nbsp;" : escapeHtml(char);
            var color = idx < splitIndex ? newColor : oldColor;
            return '<span style="color:' + color + '">' + safeChar + "</span>";
          })
          .join("");
        rotationEl.innerHTML = html;
      };

      rotationEl.textContent = words[0];
      rotationEl.style.color = baseColor;

      var scrambleTo = function (nextWord) {
        if (isAnimating) {
          return;
        }
        isAnimating = true;
        var step = 0;
        var nextColor = currentColor;
        if (colorPalette.length) {
          nextColor = colorPalette[paletteIndex % colorPalette.length];
        }
        var interval = window.setInterval(function () {
          var output = nextWord.split("").map(function (char, charIndex) {
            if (charIndex < step || char === " ") {
              return char;
            }
            return alphabet[Math.floor(Math.random() * alphabet.length)];
          });

          renderWord(output, step, currentColor, nextColor);
          step += 1;

          if (step >= nextWord.length) {
            window.clearInterval(interval);
            if (colorPalette.length) {
              currentColor = colorPalette[paletteIndex % colorPalette.length];
              paletteIndex += 1;
            }
            renderWord(nextWord.split(""), nextWord.length, currentColor, currentColor);
            isAnimating = false;
          }
        }, 75);
      };

      startRotation = function () {
        if (rotationInterval) {
          return;
        }
        rotationInterval = window.setInterval(function () {
          if (isAnimating) {
            return;
          }
          index = (index + 1) % words.length;
          scrambleTo(words[index]);
        }, 3000);
      };
    }

    var hero = document.querySelector(".hero");
    if (hero && window.DNB && typeof window.DNB.revealText === "function" && window.gsap) {
      var heroTargets = Array.prototype.slice.call(hero.querySelectorAll(".hero__line"));
      var heroLead = hero.querySelector(".hero__lead");
      if (heroLead) {
        heroTargets.push(heroLead);
      }

      if (heroTargets.length) {
        window.DNB.revealText(heroTargets, {
          stagger: 0.18,
          duration: 0.9,
          opacity: 1,
          ease: "expo.out",
          onComplete: function () {
            if (typeof startRotation === "function") {
              startRotation();
            }
          }
        });
      } else if (typeof startRotation === "function") {
        startRotation();
      }
    } else if (typeof startRotation === "function") {
      startRotation();
    }

    if (window.DNB && typeof window.DNB.revealText === "function" && window.gsap) {
      var pageHeroTitles = document.querySelectorAll("[data-hero-title]");
      pageHeroTitles.forEach(function (title) {
        if (title.dataset.heroRevealReady === "true") {
          return;
        }
        title.dataset.heroRevealReady = "true";
        var lines = Array.prototype.slice.call(title.querySelectorAll(".hero__line"));
        var targets = lines.length ? lines : [title];
        window.DNB.revealText(targets, {
          stagger: 0.18,
          duration: 0.9,
          ease: "expo.out"
        });
      });
    }

    var logoWrap = document.querySelector("[data-hero-logo]");
    var logoCanvas = logoWrap ? logoWrap.querySelector("[data-hero-logo-canvas]") : null;
    if (!logoWrap || !logoCanvas || !logoCanvas.getContext || window.innerWidth <= 678) {
      return;
    }

    if (logoWrap.dataset.heroLogoReady === "true") { 
      return;
    }
    logoWrap.dataset.heroLogoReady = "true";

    var ctx = logoCanvas.getContext("2d");
    var particles = [];
    var mouse = { x: null, y: null, radius: 80 };
    var time = 0;
    var canvasWidth = 0;
    var canvasHeight = 0;
    var animationId = null;
    var isRunning = false;
    var wantsRun = false;
    var imageReady = false;
    var image = new Image();
    image.src = "assets/images/hero-logo.png";

    var maxCanvasWidth = 650;
    var maxCanvasHeight = 750;
    if( window.innerWidth <= 1366) {
      maxCanvasWidth = 433;
      maxCanvasHeight = 500;
    }
    else if( window.innerWidth <= 1536) {
      maxCanvasWidth = 520;
      maxCanvasHeight = 600;
    }

    function resizeCanvas() {
      var rect = logoCanvas.getBoundingClientRect();
      var targetWidth = Math.min(Math.floor(rect.width), maxCanvasWidth);
      var targetHeight = Math.min(Math.floor(rect.height), maxCanvasHeight);

      logoCanvas.style.width = targetWidth + "px";
      logoCanvas.style.height = targetHeight + "px";

      canvasWidth = Math.max(targetWidth, 1);
      canvasHeight = Math.max(targetHeight, 1);
      if (logoCanvas.width !== canvasWidth || logoCanvas.height !== canvasHeight) {
        logoCanvas.width = canvasWidth;
        logoCanvas.height = canvasHeight;
      }
    }

    function getLogoScale() {
      if (!image.width || !image.height) {
        return 1;
      }
      return Math.min(canvasWidth / image.width, canvasHeight / image.height) * 0.85;
    }

    function getRandomColor() {
      // return "#6D6D6D";
      return "#000000";
    }

    function Particle(x, y) {
      this.baseX = x;
      this.baseY = y;
      this.x = x + Math.random() * 30 - 15;
      this.y = y + Math.random() * 30 - 15;
      this.size = 1;
      this.density = Math.random() * 20 + 10;
      this.offset = Math.random() * Math.PI * 2;
      this.color = getRandomColor();
    }

    Particle.prototype.draw = function () {
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
      ctx.fill();
    };

    Particle.prototype.update = function () {
      var wave = Math.sin(time + this.offset) * 4;
      var targetX = this.baseX + wave;
      var targetY = this.baseY + wave;

      if (mouse.x !== null && mouse.y !== null) {
        var dx = mouse.x - this.x;
        var dy = mouse.y - this.y;
        var dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < mouse.radius) {
          var force = (mouse.radius - dist) / mouse.radius;
          force = force * 0.6;

          this.x += (dx / dist) * force * (this.density * 0.4);
          this.y += (dy / dist) * force * (this.density * 0.4);

          var angle = Math.atan2(dy, dx) + time * 2 + dist * 0.1;
          var spiralRadius = 20 * force;
          this.x += Math.cos(angle) * spiralRadius * 0.4;
          this.y += Math.sin(angle) * spiralRadius * 0.4;

          var softVibration = Math.sin(time * 3 + this.offset) * force * 2;
          this.x += softVibration * 0.5;
          this.y += softVibration * 0.5;
        } else {
          this.x += (targetX - this.x) / 12;
          this.y += (targetY - this.y) / 12;
        }
      } else {
        this.x += (targetX - this.x) / 15;
        this.y += (targetY - this.y) / 15;
      }
    };

    function initParticles() {
      if (!image.complete) {
        return;
      }
      resizeCanvas();
      particles = [];

      var scale = getLogoScale();
      var imgW = image.width * scale;
      var imgH = image.height * scale;
      var offsetX = canvasWidth / 2 - imgW / 2;
      var offsetY = canvasHeight / 2 - imgH / 2;

      ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      ctx.drawImage(image, offsetX, offsetY, imgW, imgH);

      var data = ctx.getImageData(0, 0, canvasWidth, canvasHeight);
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);

      for (var y = 0; y < canvasHeight; y += 4) {
        for (var x = 0; x < canvasWidth; x += 4) {
          var i = (y * canvasWidth + x) * 4;
          if (data.data[i + 3] > 150) {
            particles.push(new Particle(x, y));
          }
        }
      }
    }

    function animate() {
      if (!isRunning) {
        return;
      }
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      time += 0.03;

      for (var i = 0; i < particles.length; i++) {
        particles[i].update();
        particles[i].draw();
      }

      animationId = window.requestAnimationFrame(animate);
    }

    function requestStart() {
      wantsRun = true;
      if (!imageReady || isRunning) {
        return;
      }
      isRunning = true;
      animationId = window.requestAnimationFrame(animate);
    }

    function requestStop() {
      wantsRun = false;
      if (!isRunning) {
        return;
      }
      isRunning = false;
      if (animationId) {
        window.cancelAnimationFrame(animationId);
        animationId = null;
      }
    }

    function handlePointerMove(e) {
      var rect = logoCanvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
      if (mouse.x < 0 || mouse.x > rect.width || mouse.y < 0 || mouse.y > rect.height) {
        mouse.x = null;
        mouse.y = null;
      }
    }

    function handlePointerLeave() {
      mouse.x = null;
      mouse.y = null;
      mouse.radius = 100;
    }

    function handlePointerEnter() {
      mouse.radius = 80;
    }

    logoCanvas.addEventListener("mousemove", handlePointerMove);
    logoCanvas.addEventListener("mouseenter", handlePointerEnter);
    logoCanvas.addEventListener("mouseleave", handlePointerLeave);

    window.addEventListener("resize", function () {
      initParticles();
    });

    var visibilityTrigger = logoWrap.closest(".hero") || logoWrap.closest("[data-scroll-section]") || logoWrap;

    if (window.gsap && window.ScrollTrigger) {
      var triggerOptions = {
        trigger: visibilityTrigger,
        start: "top bottom",
        end: "bottom top",
        onEnter: requestStart,
        onEnterBack: requestStart,
        onLeave: requestStop,
        onLeaveBack: requestStop,
        onToggle: function (self) {
          if (self && self.isActive) {
            requestStart();
          } else {
            requestStop();
          }
        }
      };

      if (window.DNB.scroller) {
        triggerOptions.scroller = window.DNB.scroller;
      }

      window.ScrollTrigger.create(triggerOptions);
    } else if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              requestStart();
            } else {
              requestStop();
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(visibilityTrigger);
    } else {
      requestStart();
    }

    image.onload = function () {
      imageReady = true;
      initParticles();
      if (wantsRun) {
        requestStart();
      }
    };
  });
})();
